/**
 * @name 统一注册插件
 */
import Vue from 'vue'
import './permission'
import App from './App'
import store from './store'
import router from '@/router';
import './core/install';
import directive from './directive' // directive
import plugins from './plugins' // plugins
// import echarts from 'echarts'
// import "echarts-gl";
import Cookies from 'js-cookie'

import Element from 'element-ui'
import './assets/styles/element-variables.scss'

import '@/assets/styles/index.scss' // global css
import '@/assets/styles/ruoyi.scss' // ruoyi css
import '@/assets/fonts/iconfont/iconfont.css'
import {
    stateChange,
    colorStateChange,
    box_colorStateChange
} from "@/utils/svgState";

import "@/assets/css/common.styl"
import "@/assets/css/index.scss"
// swiper轮播图的引入
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

import VueCodeMirror from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import "codemirror/theme/darcula.css";
import './assets/icons' // icon
Vue.use(VueCodeMirror);

import Bus from '@/utils/bus';
Vue.use(Bus);

import common from "@/utils/common";
import {getSessionData} from "@/utils/commonApi";
window.common = common;

Vue.prototype.$stateChange = stateChange;
Vue.prototype.$colorStateChange = colorStateChange;
Vue.prototype.$box_colorStateChange = box_colorStateChange;

// Vue.prototype.$echarts = echarts;
Vue.use(directive)
Vue.use(plugins)
// Vue.use(echarts)

Vue.use(Element, {
    size: Cookies.get('size') || 'medium' // set element-ui default size
})

let app = new Vue({
    router,
    store,
    render: h => h(App)
});
app.$mount("#app");
